const FALLBACK = "Something went wrong, please try again!!";

/**
 * The human-readable reason out of an API failure.
 *
 * Both public endpoints answer with a reason worth showing - "This order
 * cannot be changed as it's already in a packed status", "Amount should be
 * equal total amount" - and both used to be replaced by a fixed string, which
 * left customers guessing.
 *
 * Two shapes have to be handled. Axios rejections carry `response.data`, which
 * may be a string, a list, or DRF's `{field: [messages]}`. The cancel endpoint
 * answers 200 with `{success: false, message: ...}`, so `message` is checked
 * first - otherwise the first value found would be its unrelated `data` key.
 */
const firstString = (value) => {
  if (typeof value === "string") return value.trim() || null;
  if (Array.isArray(value)) {
    for (const item of value) {
      const found = firstString(item);
      if (found) return found;
    }
    return null;
  }
  if (value && typeof value === "object") {
    for (const item of Object.values(value)) {
      const found = firstString(item);
      if (found) return found;
    }
  }
  return null;
};

export const readApiError = (error) => {
  const data = error?.response?.data;
  if (!data) return FALLBACK;

  if (data && typeof data === "object" && !Array.isArray(data) && "message" in data) {
    return firstString(data.message) ?? FALLBACK;
  }

  return firstString(data) ?? FALLBACK;
};

export default readApiError;
